// extracted by mini-css-extract-plugin
module.exports = {"cls1":"BlankSlate-BlankSlateBody-module--cls1--53Zbk","cls2":"BlankSlate-BlankSlateBody-module--cls2--19c1z BlankSlate-BlankSlateBody-module--cls1--53Zbk mb-4"};